import type { FC } from "react";

import type { AddressInfoBlockProps } from "@ui/components/AddressInfoBlock";
import { AddressInfoBlock } from "@ui/components/AddressInfoBlock";

import { RadioContainer } from "@jti/core-components";
import type { AddressStored } from "@jti/fe-common";

export type AddressSelectCardProps = {
  address: AddressStored;
  onSelect: (addressId: string) => void;
  isSelected?: boolean;
  telephonePosition?: AddressInfoBlockProps["telephonePosition"];
};

export const AddressSelectCard: FC<AddressSelectCardProps> = ({ address, onSelect, isSelected, telephonePosition }) => (
  <RadioContainer
    name="address-select"
    value={address.id}
    label={<AddressInfoBlock address={address} telephonePosition={telephonePosition ?? "bottom"} />}
    checked={isSelected}
    onChange={() => onSelect(address.id)}
    data-testid="address-select-card"
  />
);
